module.exports = __webpack_public_path__ + "img/3d.f36ce24a.png";